import { MouseEvent, useEffect, useState, } from 'react';
import { FaTrash } from 'react-icons/fa';

import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { RoleBinding } from '../../types';
import { CreateTenantRoleBindingModal } from './CreateTenantRoleBindingModal';
import { selectCurrentTenantId } from '../user/userSlice';
import {
  listRoleBindingsAction,
  selectTenantRoleBindings,
  deleteRoleBindingAction,
} from './roleBindingSlice';

type Props = {
  role_id: string;
};

export function TenantRoleBindingTable({ role_id }: Props) {
  const dispatch = useAppDispatch();
  const roleBindings = useAppSelector(selectTenantRoleBindings);
  const tenant_id = useAppSelector(selectCurrentTenantId);
  const [show_modal, setShowModal] = useState(false);

  useEffect(() => {
    dispatch(listRoleBindingsAction({ tenant_id: tenant_id, role_ids: [role_id] }));
  }, [tenant_id, role_id, dispatch]);

  const handleOpenModal = async() => {
    setShowModal(true);
  };

  const handleCloseModal = async() => {
    setShowModal(false);
    dispatch(listRoleBindingsAction({ tenant_id: tenant_id, role_ids: [role_id] }));
  };

  const handleDeleteRoleBinding = async(e: MouseEvent, role_binding: RoleBinding) => {
    e.preventDefault();
    await dispatch(deleteRoleBindingAction({
      tenant_id: tenant_id,
      body: { id: role_binding.id },
    }));
    dispatch(listRoleBindingsAction({ tenant_id: tenant_id, role_ids: [role_id] }));
  };

  return (
    <div className="role-binding-list mt-3">
      <div className="d-flex justify-content-between py-4">
        <h3>{roleBindings.length || 'No'} assigned tenants</h3>
        <button className="btn btn-primary my-2" onClick={handleOpenModal}>
          Create
        </button>
      </div>
      <table className="table">
        <thead className="table-dark">
          <tr>
            <th scope="col">#</th>
            <th scope="col">SharedTenantId</th>
            <th scope="col">SharedTenantName</th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          {roleBindings.map((role_binding, index) => {
            return (
              <tr key={index}>
                <th scope="row">{ index+1 }</th>
                <td>{role_binding.shared_tenant_id}</td>
                <td>{role_binding.shared_tenant_name}</td>
                <td>
                  <a href="/#" className="text-danger" role="button"
                    onClick={(e) => handleDeleteRoleBinding(e, role_binding)}>
                    <FaTrash />
                  </a>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <CreateTenantRoleBindingModal
        tenant_id={tenant_id}
        role_id={role_id}
        show={show_modal}
        onClose={handleCloseModal}
      />
    </div>
  );
}
